import * as THREE from 'three'
import { MathUtils } from 'three'
import { useEffect, useRef, useState } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls } from '@react-three/drei'
import * as Tone from 'tone'
import inst from "./inst"
import { Instances, Instance } from '@react-three/drei'
import anime from 'animejs/lib/anime.es.js';

let colorIndex = 0
let colors = ['#4e6b62','#772f57','#005438','#b9202f']
let hit = 0;
let getInst = () => {
  hit++;
  return (hit % 2 === 0) ? inst.synthL : inst.synthR
}
let lerp = MathUtils.lerp

let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]
let notes = ["C", "D", "F", "G", "A"]
let octaves = [0, 1, 2, 3, 4, 5, 6, 7, 8]
let octaves2 = [2, 3, 4, 5]
let allNotes = new Array(notes.length * octaves.length).fill().fill().map((val, i) => {
  return notes[i % notes.length] + octaves[Math.floor(i / notes.length)]
})
let durs = [0.2]
let octaveOffset = 1;
let offsets = [1, 2, 3,4]

function Sequence({ updated, length, ready, index, y = 4000, space = 1, width = 0.07, height = 0.05, pull, max, min, scale, ...props }) {
  const ref = useRef()
  const ref2 = useRef()
  const ref3 = useRef()
  const ref4 = useRef()
  let time = 0;
  let dur = 0
  let durMult = getRand([2.5, 3.5])

  let data = Array.from({ length }, (v, i) => {
    let note = allNotes[i];
    let frac = 0.48 - (i / length)
    let size = 0.25
    let pos = {
      x: Math.cos(frac * Math.PI) * size * 1.75,
      y: Math.sin(frac * Math.PI) * size * 1.5,
      z: 0
    }
    dur = getRand(durs) * durMult;
    let velocity = (Math.random() * dur * 2)
    let scale = 1
    let ret = { time, note, i, pos, dur, currPos: { x: 0, y: 0, z: 0 }, velocity, scale, currScale: 1, durMult }
    time += dur
    return ret
  });
  let currTime = 0;

  let loopEnd = time
  const part = new Tone.Part(((time, val) => {
    if (!val.i) {
      mut.reverse = !mut.reverse
    }
    let s = getInst();
    let currI = !mut.reverse ? val.i : (length - 1) - val.i
    s.triggerAttackRelease(data[currI].note[0] + (parseInt(data[currI].note[1]) + octaveOffset), val.dur * 0.05, time, val.velocity);
    data[currI].scale = 15
    anime({
      targets: data[currI],
      scale: 1,
      duration: loopEnd * 4000
    })
    let chance = 1 - (length * 0.02)
    console.log(chance)
    if (!val.i && (Math.random() > chance)) {
      octaveOffset = getRand(offsets)
      console.log(octaveOffset)
    }

  }), data);

  useEffect(() => {
    if (ready) {
      part.start();
    }
    return () => part.stop()
  }, [ready, updated])
  part.loop = true;
  part.loopStart = 0;
  part.loopEnd = loopEnd;
  let spinSpeed = 0.0000001
  useFrame((state) => {
    //ref.current.rotation.set(0,ref.current.rotation.y + (rewind ? spinSpeed : -spinSpeed),0)
  })
  let octa = new THREE.OctahedronBufferGeometry(width * 0.2)



  let geo = getRand([octa])
  let len = 80
  let gapMax = 0.05
  let gapX = getRand([0.5,0.1]) * gapMax * 0.1
  let gapY =  getRand([0.7]) * gapMax * 0.3
  let halfX = length * gapX
  let halfY = length * gapY * 2.5
  let totRot = Math.random()*3
  //  const matcap = useLoader(THREE.TextureLoader, './C7C7D7_4C4E5A_818393_6C6C74-512px.png')
  let sz = 0.02 + (Math.random()*0.05)
  return (
    <>
      <Instances ref={ref} {...props} limit={2000} geometry={geo} position={[-halfX, -halfY, 0]}>
        <meshStandardMaterial roughness={0.3} transparent opacity={0.9} color={colors[colorIndex%colors.length]} />
        {new Array(len).fill().map((a, j) => (
          <group position={[(j * gapX), (j * gapY), 0]} rotation={[0, Math.PI * totRot * j / len, 0]}>
            {data.map((curr, i) => (
              <>
                <Note key={1} i={i} data={data} size={sz} space={0} speed={0.003} pull={pull} min={min} scale={scale} />
              </>
            ))}
          </group>
        ))}
      </Instances>
    </>
  )
}


function Note({ i, size, data, pull, min, scale, speed }) {
  const ref = useRef()
  useFrame((state) => {
    let t = state.clock.getElapsedTime()
    let lerpScale = lerp(
      data[i].currScale,
      (data[i].scale) * scale
      , speed
    )
    data[i].currScale = lerpScale;

    let p = pull * 0.01
    
    let x = data[i].currPos.x = lerp(
      data[i].currPos.x,
      -(octaveOffset * 0.03) + data[i].pos.x + (lerpScale - 0.8) * p,
      speed)
      
      let y = data[i].currPos.y = lerp(
        data[i].currPos.y,
        data[i].pos.y * p*0.1,
        speed)
    
        ref.current.scale.setScalar((Math.abs(x*1) + 0.1 +(lerpScale * size ))* mut.zoom2)

    ref.current.position.set(
      x * mut.zoom,
      y * mut.zoom,
      data[i].pos.z * mut.zoom
    )
    ref.current.rotation.set(
      lerpScale*1,0,0
    )
  })
  return (
    <>
      <Instance ref={ref} />
    </>
  )
}
let canSpawn = true;
let mut = { zoom: 1, zoom2: 1, rot: 0, rot2: 0, rot3: 0, reverse: false };
let easing = 'easeInQuart'
let easing2 = 'easeOutQuart'
let easing3 = 'easeInOutQuart'
let duration = 500
let first = false
let len = 20
export default function App() {
  const cam = useRef()

  const [ready, set] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [length, setLength] = useState(len)
  const click = () => {
    console.log(cam.current)
    colorIndex++;
    Tone.Transport.start();
    Tone.context.resume();

    if (!first) {
      duration = 400
      first = true
    }
    if (canSpawn) {
      anime({
        targets: mut,
        zoom: 0,
        zoom2: 0,
        duration,
        easing,
      })
      setTimeout(() => {
        setLength(len)
        setUpdated(!updated)
        set(true)
        canSpawn = false
        octaveOffset = getRand(offsets)
        setTimeout(() => {
          anime({
            targets: mut,
            zoom: 1,
            zoom2: 1,
            duration,
            easing: easing2,
          })
        }, 50)
        let dTime = 0.2 + Math.floor(0.2*(Math.random()*3))
        let dTime2 = 0.2 + Math.floor(0.2*(Math.random()*3))
        let rTime = 0.5 + Math.random() * 1
        inst.delayL.delayTime.linearRampToValueAtTime(dTime, rTime)
        inst.delayR.delayTime.linearRampToValueAtTime(dTime2, rTime)

      }, duration + 50)
      let val = 2000;
      let time = (duration * 2) / 1000;
      inst.filterL.frequency.rampTo(val, time * 0.5);
      inst.filterR.frequency.rampTo(val, time * 0.5)
      setTimeout(() => {
        inst.filterL.frequency.rampTo(inst.defaultFreq, time);
        inst.filterR.frequency.rampTo(inst.defaultFreq, time)

      }, time * 1000)
      anime({
        targets: mut,
        rot: mut.rot + getRand([1]) * getRand([1, -1]),
        duration: duration * 2,
        easing: easing3,
        complete: function (anim) {
          canSpawn = true
        }
      })

    }
  }
  let isMobile = window.innerWidth < 800
  return (
    <div className="fullscreen" onMouseDown={() => { click() }}>
       <div className="background">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      <div className="border">
        <div />
        <div />
        <div />
        <div />
      </div>
      <Canvas gl={{ antialias: true }} dpr={[1, 2]} camera={{ position: [0, 0.4,isMobile ? 1 : 0.9], fov: 55 }}>
        <OrbitControls autoRotate autoRotateSpeed={0.15} ref={cam} />
        <ambientLight intensity={0.75} />
        <pointLight position={[-30, 10, 5]} intensity={6} />
        <pointLight position={[30, 10, -5]} intensity={3} />
        <Sequence updated={updated} index={1} ready={ready} length={length} pull={(Math.random() * 1.5) - 0.75} min={(Math.random() * getRand([0.3, 0.5, 1.5])) + 0.02} scale={(Math.random() * 0.8) + 0.1} />
      </Canvas>
    </div>
  )
}

console.log('%c🌱🌱 @ramioso 2021-10-27 🌱🌱 ', 'color: orange');